import { call, put, delay } from 'redux-saga/effects'
import _ from 'lodash'
import toast from 'react-hot-toast'
import { v4 } from 'uuid'

import api from 'Src/api'

import { fetchAnswersSuccess } from 'Actions/answers'

const LIST_ANSWERS_URL = 'v1/answers'
const DELETE_ANSWER_URL = 'v1/answers/:answer_id'

const fetchAnswersToastId = v4()

export const fetchAnswers = function* ({ payload }) {
  try {
    const answerParams = _.pick(payload, ['offset', 'limit', 'search', 'sort_by', 'order_by'])

    if (payload?.showToast) {
      toast.loading('Fetching data...', {
        id: fetchAnswersToastId
      })
    }

    const response = yield call(api.get, LIST_ANSWERS_URL, {
      params: _.pickBy(answerParams, _.identity)
    })

    const { results, meta } = response.data

    yield put(fetchAnswersSuccess({ answers: results, totalCount: meta.total }))
    toast.dismiss(fetchAnswersToastId)
  } catch (error) {
    toast.error('Error while fetching answers', {
      id: fetchAnswersToastId
    })

    console.error('Unable to fetch answers', error)
  }
}

export const deleteAnswer = function* (answerId) {
  try {
    yield call(api.delete, DELETE_ANSWER_URL, {
      urlParams: {
        answer_id: answerId
      }
    })
    yield delay(100)
    yield call(fetchAnswers, {})
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message)
    } else {
      toast.error('Unable to delete answer. Try again...')
    }
    console.error('Unable to delete answer', error)
  }
}
